import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthShell from "./AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { BRAND } from "@/branding.config";

export default function Verify() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setState("invalid"); return; }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setState("done");
      } catch (err) {
        setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        setState("failed");
      }
    })();
  }, [token]);

  return (
    <AuthShell title="Verify email" subtitle={`Confirming your ${BRAND.app_name} account…`}
      footer={<Link to="/portal" className="text-primary hover:underline">Continue to portal →</Link>}
    >
      {state === "verifying" && (
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <div className="h-5 w-5 rounded-full border-2 border-primary/30 border-t-primary animate-spin" />
          Verifying your email…
        </div>
      )}
      {state === "done" && (
        <div className="rounded-xl border border-emerald-500/25 bg-emerald-500/10 text-emerald-500 p-4 text-sm">
          Email verified. You're all set.
        </div>
      )}
      {state === "failed" && (
        <div className="rounded-xl border border-red-500/25 bg-red-500/10 text-red-500 p-4 text-sm">{error || "Verification failed."}</div>
      )}
      {state === "invalid" && (
        <div className="text-sm text-muted-foreground">Missing verification token.</div>
      )}
    </AuthShell>
  );
}
